import React from "react";
import { Link } from "react-router-dom";
import type { AdminSeason } from "../api/types";
import { Notice, Pill, Section, SectionTitle, Small, Table, TableWrap } from "./adminStyles";

const TASK_TEXT: Record<string, string> = {
  "game-lifecycle": "moves the stored status with the dates (every 5 minutes)",
  "game-day-sweep": "settles and finalizes days a missed event left behind (hourly)",
  "game-teaser": "sends the 3-day and 1-day teasers, once each (hourly check)",
};

/** Read-only: the three game tasks. They are switched on the scheduler page. */
const SchedulerPanel: React.FC<{ season: AdminSeason }> = ({ season }) => {
  const s = season.scheduler;
  return (
    <Section aria-label="Scheduler">
      <SectionTitle>Scheduler</SectionTitle>
      <Small style={{ marginBottom: 8 }}>
        Turn these on or off on the <Link to="/admin/scheduler" style={{ color: "#663399" }}>scheduler page</Link>.
      </Small>
      {!s && <Notice tone="warn">Could not read the scheduler.</Notice>}
      {s && !s.schedulerGloballyEnabled && (
        <Notice tone="warn">The scheduler is off on this backend (SCHEDULER_ENABLED is not true), so no task runs.</Notice>
      )}
      {s && s.schedulerGloballyEnabled && !s.schedulerRunning && (
        <Notice tone="warn">The scheduler is not running yet. Check the backend logs.</Notice>
      )}
      {s && (
        <TableWrap>
          <Table aria-label="Game tasks">
            <thead>
              <tr>
                <th>Task</th>
                <th>Enabled</th>
                <th>Running</th>
                <th>What it does</th>
              </tr>
            </thead>
            <tbody>
              {s.tasks.map((t) => (
                <tr key={t.name}>
                  <td>
                    <code>{t.name}</code>
                  </td>
                  <td>
                    <Pill tone={t.enabled ? "ok" : "off"}>{t.enabled ? "on" : "off"}</Pill>
                    {!t.seeded && <Small as="span"> (default)</Small>}
                  </td>
                  <td>{t.running ? "yes" : "no"}</td>
                  <td style={{ whiteSpace: "normal", minWidth: 200 }}>{TASK_TEXT[t.name] ?? t.cron}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrap>
      )}
    </Section>
  );
};

export default SchedulerPanel;
